/* Implementation of the Night Owl Light theme for VS Code
Original: https://github.com/sdras/night-owl-vscode-theme */

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #403f53;
	--pce-bg: #fbfbfb;
	--pce-widget-border: #ccc;
	--pce-widget-bg: #fbfbfb;
	--pce-widget-color: #403f53;
	--pce-widget-color-active: #000;
	--pce-widget-color-options: #5e6578;
	--pce-widget-bg-input: #f0f0f0;
	--pce-widget-bg-hover: #b8b8b84f;
	--pce-widget-bg-active: #c2dff2;
	--pce-widget-focus: #0077f0;
	--pce-search-match: #707e8859;
	--pce-widget-bg-error: #f76e6e;
	--pce-widget-error: #de3d3b;
	--pce-bg-highlight: #f0f0f0;
	--pce-selection-match: #339cec22;
	--pce-line-number: #6c7489;
	--pce-scrollbar: 207, 10%, 40%;
	--pce-bg-fold: #424242;
	--pce-guide-indent: #0012;
	--pce-ac-icon-class: #d67e00;
	--pce-ac-icon-enum: #d67e00;
	--pce-ac-icon-event: #d67e00;
	--pce-ac-icon-function: #652d90;
	--pce-ac-icon-interface: #007acc;
	--pce-ac-icon-variable: #007acc;
	--pce-ac-match: #0066bf;
	--pce-tabstop: #0a326433;
	--pce-invisibles: #3333;
	--pce-selection: #cbe3f6;
	color-scheme: light;
}

.match-highlight {
	--pce-bg-highlight: #7497a633;
}

.pce-match {
	--pce-search-match: #707e8870;
}

.active-line {
	--pce-line-number: #111;
}

.active-indent {
	--pce-guide-indent: #0014;
}

/* Tokens */

.token.comment,
.token.prolog,
.token.cdata {
	color: #5e6578;
	font-style: italic;
}

.token.namespace {
	opacity: 0.7;
}

.token.property {
	color: #097174;
}

.token.tag,
.token.tag > .punctuation,
.token.doctype > .punctuation,
.token.doctype-tag,
.token.attr-equals,
.token.keyword,
.token.punctuation,
.token.literal-property,
.token.operator,
.token.token.anchor,
.token.atrule .rule,
.language-css .important,
.language-markdown .italic * {
	color: #8d46b4;
}

[class*="language-"],
.language-css .punctuation,
.block > .punctuation,
.token.code.keyword,
.token.url > .content,
.token.atrule,
.token.parameter {
	color: #403f53;
}

.selector .punctuation {
	color: #c792ea;
}

.token.number,
.regex .escape,
.token.tag > .class-name,
.token.unit,
.token.color.hexcode,
.selector .id {
	color: #aa0982;
}

.token.boolean,
.token.keyword-null {
	color: #a54a4a;
}

.language-markdown .token.url,
.token.deleted {
	color: #bb374d;
}

.token.color,
.selector .combinator,
.selector .operator,
.token.property-access,
.token.quantifier,
.token.alternation,
.token.url > .markup-bracket {
	color: #097174;
}

.language-regex,
.token.regex-flags {
	color: #3a6a90;
}

.token.attr-name,
.token.doctype,
.token.variable,
.selector .class,
.selector .pseudo-element,
.selector .pseudo-class,
.token.builtin,
.token.bold *,
.token.code.code-snippet,
.token.function,
.token.constant,
.token.keyword-undefined,
.token.entity,
.token.char-class,
.token.token.char-set,
.token.title.important,
.token.title > .punctuation,
.token.url > .variable {
	color: #3c63b3;
}

.token.inserted {
	color: #5aa329;
}

.token.selector,
.token.attr-value,
.token.char,
.token.string,
.token.string-property {
	color: #9b504e;
}

.token.attr-value > .punctuation,
.token.class-name,
.token.maybe-class-name {
	color: #111;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.function,
.token.keyword,
.token.italic,
.token.attr-name,
.token.pseudo-class,
.token.pseudo-element,
.selector .class,
.selector .id,
.token.atrule .rule,
.doctype .name {
	font-style: italic;
}

.language-css .function {
	font-style: normal;
}

.token.alternation,
.token.keyword-this,
.token.keyword-null,
.token.keyword-undefined {
	font-style: normal;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #0431fa;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #277927;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #7b3814;
}

.token.interpolation-punctuation {
	color: #b73936;
}

.token.bracket-error {
	color: #ff1212;
}

.token.markup-bracket,
.token.regex .punctuation {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #00806fab, inset 0 0 0 9in #198de626;
}

.active-tagname,
.word-matches span {
	background: #471e3c33;
}
